import React, { useCallback } from 'react';

import styled from 'styled-components';
import { StyledBox, StyledGrid, VerticalFlexContainer } from 'styles/common';

import CurrentRoleImage from 'assets/images/CurrentRoleImage.png';
import NextRoleImage from 'assets/images/NextRoleImage.png';

import theme from 'constants/theme';

import { TextButtonHoverFilled } from 'uiToolkit/Button';
import { Typography13, Typography14 } from 'uiToolkit/Typography';

import { useLevelUpContext } from '../context';

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const StyledTextButtonHoverFilled = styled(TextButtonHoverFilled)`
  minheight: 192px;
  width: 100%;
  height: 100%;
  & > span {
    height: 100%;
  }
`;

const ActionCard = ({ imageSrc, imageAlt, label, onClick }) => (
  <StyledTextButtonHoverFilled
    borderColor={theme.palette.borders.lighterGrey}
    padding="16px"
    onClick={onClick}
    color={theme.palette.background.lightBlue}
  >
    <VerticalFlexContainer style={{ alignItems: 'center', justifyContent: 'flex-end' }}>
      <StyledBox>
        <StyledImage src={imageSrc} alt={imageAlt} />
      </StyledBox>
      <Typography14 topGutter={2} weight={600} color={theme.palette.text.blackv1}>
        {label}
      </Typography14>
    </VerticalFlexContainer>
  </StyledTextButtonHoverFilled>
);

export const Step2 = () => {
  const {
    state: { levelUpDetails },
    openRoleSelectionModal,
    handleRoleSelect,
  } = useLevelUpContext();

  const handleChooseCurrentRole = useCallback(() => {
    handleRoleSelect({
      jobFunctionId: levelUpDetails.currentJobFunction.uuid,
      jobRoleId: levelUpDetails.currentJobRole.uuid,
    });
  }, [levelUpDetails.currentJobFunction.uuid, levelUpDetails.currentJobRole.uuid]);

  const handleChooseNewRole = () => {
    openRoleSelectionModal({ isNewRoleSelection: true });
  };

  return (
    <>
      <Typography13 topGutter={3} bottomGutter={2} color={theme.palette.text.label}>
        Step 2
      </Typography13>
      <Typography13 color={theme.palette.text.blackv1}>Please select what you want to do next</Typography13>
      <StyledGrid container topGutter={3} style={{ alignItems: 'stretch' }}>
        <StyledGrid item xs={6} style={{ paddingRight: '0.75rem' }}>
          <ActionCard
            imageSrc={CurrentRoleImage}
            imageAlt="Current Role Image"
            onClick={handleChooseCurrentRole}
            label="Focus on your current role"
          />
        </StyledGrid>
        <StyledGrid item xs={6} style={{ paddingLeft: '0.75rem' }}>
          <ActionCard
            imageSrc={NextRoleImage}
            imageAlt="Next Role Image"
            onClick={handleChooseNewRole}
            label="Work towards a new role"
          />
        </StyledGrid>
      </StyledGrid>
    </>
  );
};
